import { render, staticRenderFns } from "./WdmDesigner.vue?vue&type=template&id=06ef94c1&"
import script from "./WdmDesigner.vue?vue&type=script&lang=js&"
export * from "./WdmDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WdmDesigner.vue?vue&type=style&index=0&id=06ef94c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports